export default __webpack_public_path__ + "static/media/img-02-mini.6c4e0ed8.png";